import React from 'react';
import { ConnectedConfiguratorScreen } from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Screen';
import ThemeProvider from './ThemeProvider';
import CreatorLayout from './Layout';

const ConfiguratorScreen = (props) => (
  <ConnectedConfiguratorScreen
    {...props}
    CreatorScreen={CreatorLayout}
    ThemeProvider={ThemeProvider}
    selectedConfigurationMode={'creator'}
  />
);

export default ConfiguratorScreen;
